import { useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner"; // ✅ Add this import
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import DemoPage from "./pages/DemoPage";
import SearchResults from "./pages/SearchResults";
import WorkInProgress from "./pages/WorkInProgress";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { HelmetProvider } from 'react-helmet-async';

import AdminLayout from "./components/admin/AdminLayout";
import AdminHomepage from "./pages/admin/AdminHomepage";
import MessagesPage from "./pages/admin/MessagesPage";
import SEOModule from "./pages/admin/SEOModule";
import CustomerLeadsPage from "./pages/admin/CustomerLeadsPage";
import MarketingPage from "./pages/admin/MarketingPage";
import SecurityPrivacyPage from "./pages/admin/SecurityPrivacyPage";
import CmsSqlManagerPage from "./pages/admin/CmsSqlManagerPage";
import AutomationsPage from "./pages/admin/AutomationsPage";
import AnalyticsDashboard from './pages/admin/AnalyticsDashboard';

const AppWrapper = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  // ✅ Inject Clarity script for public routes only
  useEffect(() => {
    if (!isAdminRoute) {
      if (!document.getElementById("clarity-script")) {
        const script = document.createElement("script");
        script.id = "clarity-script";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "r2505dllux");`;
        document.head.appendChild(script);
      }

      setTimeout(() => {
        const [nav] = performance.getEntriesByType("navigation");
        if (window.clarity && nav) {
          window.clarity("set", "dnsLookupTime", nav.domainLookupEnd - nav.domainLookupStart);
          window.clarity("set", "pageLoadTime", nav.loadEventEnd - nav.startTime);
          window.clarity("set", "connectTime", nav.connectEnd - nav.connectStart);
          window.clarity("set", "ttfb", nav.responseStart - nav.requestStart);
        }
      }, 3000);
    }
  }, [isAdminRoute]);

  return (
    <>
      {!isAdminRoute && <Navbar />}
      {!isAdminRoute && <CookieBanner />} {/* 👈 ADD THIS */}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/wip" element={<WorkInProgress />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<WorkInProgress />} />
        <Route path="/cookies" element={<WorkInProgress />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout><AdminHomepage /></AdminLayout>} />
        <Route path="/admin/messages" element={<AdminLayout><MessagesPage /></AdminLayout>} />
        <Route path="/admin/seo" element={<AdminLayout><SEOModule /></AdminLayout>} />
        <Route path="/admin/customers" element={<AdminLayout><CustomerLeadsPage /></AdminLayout>} />
        <Route path="/admin/marketing" element={<AdminLayout><MarketingPage /></AdminLayout>} />
        <Route path="/admin/security" element={<AdminLayout><SecurityPrivacyPage /></AdminLayout>} />
        <Route path="/admin/data" element={<AdminLayout><CmsSqlManagerPage /></AdminLayout>} />
        <Route path="/admin/automations" element={<AdminLayout><AutomationsPage /></AdminLayout>} />
        <Route path="/admin/analytics" element={<AdminLayout><AnalyticsDashboard /></AdminLayout>} />

        {/* Catch-all Route for 404s */}
        <Route path="*" element={<WorkInProgress />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppWrapper />
      </Router>
    </HelmetProvider>
  );
}

export default App;
